import React from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";

import Features from "@components/Unit/Features/Features";
import OpeningHoursBlock from "@components/Unit/OpeningHoursBlock/OpeningHoursBlock";
import { FEATURE_TYPE } from "@constants/unitDetails";
import { FeaturesBlockPropType } from "@models/components/organisation.model";
import { getLocationType, locationType } from "@models/services/organisation";
import { userProfile } from "@models/services/user";
import { applyLocalization } from "@services/common.service";

const FeaturesBlock: React.FC<FeaturesBlockPropType> = ({
  resourceInfo,
  terminology,
}) => {
  const context: [getLocationType, locationType, userProfile] =
    useOutletContext();
  const { t } = useTranslation();
  const unitFeatures = [
    {
      default: resourceInfo?.resourceSize
        ? t("unitSizeValue", {
            size: resourceInfo?.resourceSize,
          })
        : "",
      title: t("unitSize", {
        unit: applyLocalization(
          context?.[1]?.resourceType?.terminology?.singular
        ),
      }),
    },
    {
      default: resourceInfo?.maxCapacity
        ? t("capacityPeople", {
            maxCapacity: resourceInfo?.maxCapacity,
          })
        : "",
      title: t("capacity"),
    },
  ];

  if (
    !(
      resourceInfo?.maxCapacity ||
      resourceInfo?.resourceSize ||
      resourceInfo?.labels?.length
    )
  ) {
    return;
  }

  return (
    <div className="fg-unit-info-section" data-testid="fg-unit-info-section">
      <div className="fg-tab-welcome-block fg-border-none d-lg-none">
        <OpeningHoursBlock
          resourceInfo={resourceInfo}
          terminology={terminology}
        />
      </div>

      <Features
        label={t("resourceInfo", {
          unit: applyLocalization(
            context?.[1]?.resourceType?.terminology?.singular
          ),
        })}
        features={unitFeatures}
        type={FEATURE_TYPE.INFO}
      />
      <Features
        label=""
        features={resourceInfo?.labels}
        type={FEATURE_TYPE.LABEL}
        showBottomBorder={false}
      />
    </div>
  );
};

export default FeaturesBlock;
